// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "client-editor/" + ({"404":"TagsFilter","405":"TabsFilter","557":"DropdownFilter","586":"wix-bookings-services-preferences-modal"}[chunkId] || chunkId) + ".chunk.min.css";
};